import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import FixedSection from "../../Components/FixedSection";
import { useParams } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { api } from "methods/api";
import Spinner from "pages/SpinnerPage/Spinner";
import { imgPath } from "methods/img";
import { ShoppingCardType } from "types/Shopping";
import { homeContext } from "pages/HomeContext";
import RenderRte from "Components/RenderRte";
import { LocalNavLink } from "hooks/useLocalNavigate";

function ShopCard() {
  const { id } = useParams();
  const [status, setStatus] = useState<"none" | "loading" | "done">("none");
  const [products, setProducts] = useState<ShoppingCardType | undefined>(
    undefined
  );
  const { homeData } = useContext(homeContext);

  function getProductsData() {
    setStatus("loading");
    axios
      .get<{ data: ShoppingCardType }>(api(`shop/${id}`))
      .then(({ data }) => {
        setStatus("done");
        setProducts(data.data);
      })
      .catch((error) => {
        console.log("error", error);
        setStatus("none");
      });
  }

  useEffect(() => {
    getProductsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      {status == "done" ? (
        <>
          <FixedSection title={homeData?.siteInformation?.explorer_title} />
          <Stack sx={{ padding: "80px 30px" }}>
            <Typography
              variant="h3"
              sx={{ textAlign: "center", fontWeight: 600, mb: 10 }}
            >
              {products?.category_name}
            </Typography>
            <Container>
              <Grid container spacing={2}>
                {products?.shops?.map((card, index) => (
                  <Grid item md={4} key={card.id ?? index}>
                    {/* الكارت كله لينك لصفحة التفاصيل */}
                    <Card
                      component={LocalNavLink}
                      to={`/service/${id}/${card.id}`}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        minHeight: "400px",
                        backgroundColor: "#fff",
                        border: "2px solid",
                        borderRadius: "10px",
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer",
                        "&:hover .line": { width: 1 },
                        "&:hover img": { transform: "scale(1.1)" },
                      }}
                    >
                      <Box sx={{ overflow: "hidden", height: "250px" }}>
                        <img
                          src={imgPath(card?.images?.[0]?.image)}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transition: "all .5s",
                            display: "block",
                          }}
                          alt=""
                        />
                      </Box>

                      <CardContent>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 700,
                            marginY: 0.5,
                            display: "inline-block",
                          }}
                        >
                          {card.name}
                        </Typography>
                        <Box
                          color="#F19B02"
                          sx={{ borderBottom: "dashed 1px #000", pb: 2 }}
                        >
                          <StarIcon />
                          <StarIcon />
                          <StarIcon />
                          <StarIcon />
                          <StarIcon />
                        </Box>
                        <Typography variant="body1" component="div" sx={{ my: 1 }}>
                          <RenderRte rte={card.description} more noToggle />
                        </Typography>
                        <Typography variant="h4" sx={{ fontWeight: 600 }}>
                          {card.cost}
                        </Typography>
                      </CardContent>

                      <Box
                        sx={{
                          width: 0,
                          height: "5px",
                          backgroundColor: "primary.main",
                          transition: "all .8s",
                        }}
                        className={"line"}
                      ></Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Stack>
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
}

export default ShopCard;